import GetAniosCursos from '@/modules/capacitaciones/application/GetAniosCursos'
import GetAnioCursoById from '@/modules/capacitaciones/application/GetAnioCursoById'
import GetPerfilesCursosByAnioCurso from '@/modules/capacitaciones/application/GetPerfilesCursosByAnioCurso'
import GetPerfilCursoByAnioCursoAndId from '@/modules/capacitaciones/application/GetPerfilCursoByAnioCursoAndId'
import GetPerfilesCursos from '@/modules/capacitaciones/application/GetPerfilesCursos'
import GetPerfilCursoById from '@/modules/capacitaciones/application/GetPerfilCursoById'
import GetCategoriasByPerfilCurso from '@/modules/capacitaciones/application/GetCategoriasByPerfilCurso'
import GetCategoriaByPerfilCursoAndId from '@/modules/capacitaciones/application/GetCategoriaByPerfilCursoAndId'
import GetCategoriasByTipoCurso from '@/modules/capacitaciones/application/GetCategoriasByTipoCurso'
import GetCategoriaByTipoCursoAndId from '@/modules/capacitaciones/application/GetCategoriaByTipoCursoAndId'
import GetCategorias from '@/modules/capacitaciones/application/GetCategorias'
import GetCategoriaById from '@/modules/capacitaciones/application/GetCategoriaById'
import CrearAnioCurso from '@/modules/capacitaciones/application/CrearAnioCurso'
import ActualizarAnioCurso from '@/modules/capacitaciones/application/ActualizarAnioCurso'
import DesactivarAnioCurso from '@/modules/capacitaciones/application/DesactivarAnioCurso'
import CrearPerfilCurso from '@/modules/capacitaciones/application/CrearPerfilCurso'
import ActualizarPerfilCurso from '@/modules/capacitaciones/application/ActualizarPerfilCurso'
import DesactivarPerfilCurso from '@/modules/capacitaciones/application/DesactivarPerfilCurso'
import CrearCategoria from '@/modules/capacitaciones/application/CrearCategoria'
import ActualizarCategoria from '@/modules/capacitaciones/application/ActualizarCategoria'
import DesactivarCategoria from '@/modules/capacitaciones/application/DesactivarCategoria'
import DesactivarSubcategoria from '@/modules/capacitaciones/application/DesactivarSubcategoria'
import RemoverAsignacionCurso from '@/modules/capacitaciones/application/RemoverAsignacionCurso'
import GetAllCursosNoProgramadosPersonal from '@/modules/capacitaciones/application/GetAllCursosNoProgramadosPersonal'
import GetCursosNoProgramadosByPersonal from '@/modules/capacitaciones/application/GetCursosNoProgramadosByPersonal'
import VincularPersonalACurso from '@/modules/capacitaciones/application/VincularPersonalACurso'
import DesvincularPersonalDeCurso from '@/modules/capacitaciones/application/DesvincularPersonalDeCurso'
import ActualizarCursoNoProgramadoPersonal from '@/modules/capacitaciones/application/ActualizarCursoNoProgramadoPersonal'
import CapacitacionesApiRepository from '@/modules/capacitaciones/infrastructure/CapacitacionesApiRepository'
import { axios } from '@/plugins/axios'
import { ACTION_STATUS } from '@/const'

const repository = new CapacitacionesApiRepository()

export default {
  namespaced: true,

  state: {
    status: ACTION_STATUS.IDLE,
    aniosCursos: [],
    selectedAnioCurso: null,
    perfilesCursosDeAnio: [],
    selectedPerfilCursoDeAnio: null,
    perfilesCursos: [],
    selectedPerfilCurso: null,
    categoriasDePerfilCurso: [],
    selectedCategoriaDePerfilCurso: null,
    categoriasDeTipoCurso: [],
    selectedCategoriaDeTipoCurso: null,
    categorias: [],
    selectedCategoria: null,
    cursosNoProgramadosPersonal: [],
    cursosNoProgramadosDePersonal: [],
    // NOTA (EDF-374): GET /cursosNoProgramadosPersonal no regresa el CUIP del
    // personal vinculado. Se guarda aquí en memoria (fk_idPersonal -> CUIP) al
    // momento de vincular, para que EvaluaCurso.vue lo pueda mostrar mientras
    // dure la sesión del navegador.
    cuipsPorPersonal: {},
    catalogoNavegacion: {
      buscaCurso: '',
      expandedAnio: null,
      expandedPerfil: null,
      expandedTipo: null,
      expandedCategoria: null,
    },
  },

  getters: {
    getStatus: (state) => state.status,
    getAniosCursos: (state) => state.aniosCursos,
    getSelectedAnioCurso: (state) => state.selectedAnioCurso,
    getPerfilesCursosDeAnio: (state) => state.perfilesCursosDeAnio,
    getSelectedPerfilCursoDeAnio: (state) => state.selectedPerfilCursoDeAnio,
    getPerfilesCursos: (state) => state.perfilesCursos,
    getSelectedPerfilCurso: (state) => state.selectedPerfilCurso,
    getCategoriasDePerfilCurso: (state) => state.categoriasDePerfilCurso,
    getSelectedCategoriaDePerfilCurso: (state) => state.selectedCategoriaDePerfilCurso,
    getCategoriasDeTipoCurso: (state) => state.categoriasDeTipoCurso,
    getSelectedCategoriaDeTipoCurso: (state) => state.selectedCategoriaDeTipoCurso,
    getCategorias: (state) => state.categorias,
    getSelectedCategoria: (state) => state.selectedCategoria,
    getCursosNoProgramadosPersonal: (state) => state.cursosNoProgramadosPersonal,
    getCursosNoProgramadosDePersonal: (state) => state.cursosNoProgramadosDePersonal,
    getCuipsPorPersonal: (state) => state.cuipsPorPersonal,
    getCatalogoNavegacion: (state) => state.catalogoNavegacion,
  },

  mutations: {
    SET_STATUS(state, status) {
      state.status = status
    },
    SET_ANIOS_CURSOS(state, aniosCursos) {
      state.aniosCursos = aniosCursos
    },
    SET_SELECTED_ANIO_CURSO(state, anioCurso) {
      state.selectedAnioCurso = anioCurso
    },
    SET_PERFILES_CURSOS_DE_ANIO(state, perfilesCursos) {
      state.perfilesCursosDeAnio = perfilesCursos
    },
    SET_SELECTED_PERFIL_CURSO_DE_ANIO(state, perfilCurso) {
      state.selectedPerfilCursoDeAnio = perfilCurso
    },
    SET_PERFILES_CURSOS(state, perfilesCursos) {
      state.perfilesCursos = perfilesCursos
    },
    SET_SELECTED_PERFIL_CURSO(state, perfilCurso) {
      state.selectedPerfilCurso = perfilCurso
    },
    SET_CATEGORIAS_DE_PERFIL_CURSO(state, categorias) {
      state.categoriasDePerfilCurso = categorias
    },
    SET_SELECTED_CATEGORIA_DE_PERFIL_CURSO(state, categoria) {
      state.selectedCategoriaDePerfilCurso = categoria
    },
    SET_CATEGORIAS_DE_TIPO_CURSO(state, categorias) {
      state.categoriasDeTipoCurso = categorias
    },
    SET_SELECTED_CATEGORIA_DE_TIPO_CURSO(state, categoria) {
      state.selectedCategoriaDeTipoCurso = categoria
    },
    SET_CATEGORIAS(state, categorias) {
      state.categorias = categorias
    },
    SET_SELECTED_CATEGORIA(state, categoria) {
      state.selectedCategoria = categoria
    },
    SET_CURSOS_NO_PROGRAMADOS_PERSONAL(state, cursosNoProgramadosPersonal) {
      state.cursosNoProgramadosPersonal = cursosNoProgramadosPersonal
    },
    SET_CURSOS_NO_PROGRAMADOS_DE_PERSONAL(state, cursosNoProgramadosDePersonal) {
      state.cursosNoProgramadosDePersonal = cursosNoProgramadosDePersonal
    },
    SET_CUIP_PERSONAL(state, { fk_idPersonal, cuip }) {
      if (!fk_idPersonal || !cuip) return
      state.cuipsPorPersonal = { ...state.cuipsPorPersonal, [fk_idPersonal]: cuip }
    },
    SET_CATALOGO_NAVEGACION(state, catalogoNavegacion) {
      state.catalogoNavegacion = { ...state.catalogoNavegacion, ...catalogoNavegacion }
    },
  },

  actions: {
    async fetchAniosCursos({ commit }) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const aniosCursos = await new GetAniosCursos(repository).execute()
        commit('SET_ANIOS_CURSOS', aniosCursos)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener los años curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchAnioCursoById({ commit }, idAnioCurso) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const anioCurso = await new GetAnioCursoById(repository).execute(idAnioCurso)
        commit('SET_SELECTED_ANIO_CURSO', anioCurso)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener el año curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchPerfilesCursosByAnioCurso({ commit }, idAnioCurso) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const perfilesCursos = await new GetPerfilesCursosByAnioCurso(repository).execute(idAnioCurso)
        commit('SET_PERFILES_CURSOS_DE_ANIO', perfilesCursos)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener los perfiles del año curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchPerfilCursoByAnioCursoAndId({ commit }, { idAnioCurso, idPerfilCurso }) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const perfilCurso = await new GetPerfilCursoByAnioCursoAndId(repository).execute(idAnioCurso, idPerfilCurso)
        commit('SET_SELECTED_PERFIL_CURSO_DE_ANIO', perfilCurso)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener el perfil del año curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchPerfilesCursos({ commit }) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const perfilesCursos = await new GetPerfilesCursos(repository).execute()
        commit('SET_PERFILES_CURSOS', perfilesCursos)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener los perfiles curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchPerfilCursoById({ commit }, idPerfilCurso) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const perfilCurso = await new GetPerfilCursoById(repository).execute(idPerfilCurso)
        commit('SET_SELECTED_PERFIL_CURSO', perfilCurso)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener el perfil curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchCategoriasByPerfilCurso({ commit }, idPerfilCurso) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const categorias = await new GetCategoriasByPerfilCurso(repository).execute(idPerfilCurso)
        commit('SET_CATEGORIAS_DE_PERFIL_CURSO', categorias)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener las categorías del perfil curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchCategoriaByPerfilCursoAndId({ commit }, { idPerfilCurso, idCategoria }) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const categoria = await new GetCategoriaByPerfilCursoAndId(repository).execute(idPerfilCurso, idCategoria)
        commit('SET_SELECTED_CATEGORIA_DE_PERFIL_CURSO', categoria)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener la categoría del perfil curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchCategoriasByTipoCurso({ commit }, idTipoCurso) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const categorias = await new GetCategoriasByTipoCurso(repository).execute(idTipoCurso)
        commit('SET_CATEGORIAS_DE_TIPO_CURSO', categorias)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener las categorías del tipo de curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchCategoriaByTipoCursoAndId({ commit }, { idTipoCurso, idCategoria }) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const categoria = await new GetCategoriaByTipoCursoAndId(repository).execute(idTipoCurso, idCategoria)
        commit('SET_SELECTED_CATEGORIA_DE_TIPO_CURSO', categoria)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener la categoría del tipo de curso.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchCategorias({ commit }) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const categorias = await new GetCategorias(repository).execute()
        commit('SET_CATEGORIAS', categorias)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener las categorías.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchCategoriaById({ commit }, idCategoria) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const categoria = await new GetCategoriaById(repository).execute(idCategoria)
        commit('SET_SELECTED_CATEGORIA', categoria)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener la categoría.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async crearAnioCurso({ commit, dispatch }, payload) {
      try {
        await new CrearAnioCurso(repository).execute(payload)
        commit('SET_SNACKBAR_MESSAGE', 'El año curso se creó correctamente.', { root: true })
        await dispatch('fetchAniosCursos')
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible crear el año curso.', { root: true })
        throw error
      }
    },

    async actualizarAnioCurso({ commit, dispatch }, { idAnioCurso, payload }) {
      try {
        await new ActualizarAnioCurso(repository).execute(idAnioCurso, payload)
        commit('SET_SNACKBAR_MESSAGE', 'El año curso se actualizó correctamente.', { root: true })
        await dispatch('fetchAniosCursos')
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible actualizar el año curso.', { root: true })
        throw error
      }
    },

    async desactivarAnioCurso({ commit, dispatch }, idAnioCurso) {
      try {
        await new DesactivarAnioCurso(repository).execute(idAnioCurso)
        commit('SET_SNACKBAR_MESSAGE', 'El año curso se eliminó correctamente.', { root: true })
        await dispatch('fetchAniosCursos')
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible eliminar el año curso.', { root: true })
        throw error
      }
    },

    async crearPerfilCurso({ commit, dispatch }, payload) {
      try {
        await new CrearPerfilCurso(repository).execute(payload)
        commit('SET_SNACKBAR_MESSAGE', 'El perfil curso se creó correctamente.', { root: true })
        await dispatch('fetchPerfilesCursosByAnioCurso', payload.fk_idCatAnioCurso)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible crear el perfil curso.', { root: true })
        throw error
      }
    },

    async actualizarPerfilCurso({ commit, dispatch }, { idPerfilCurso, payload }) {
      try {
        await new ActualizarPerfilCurso(repository).execute(idPerfilCurso, payload)
        commit('SET_SNACKBAR_MESSAGE', 'El perfil curso se actualizó correctamente.', { root: true })
        await dispatch('fetchPerfilesCursosByAnioCurso', payload.fk_idCatAnioCurso)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible actualizar el perfil curso.', { root: true })
        throw error
      }
    },

    async desactivarPerfilCurso({ commit, dispatch }, { idPerfilCurso, idAnioCurso }) {
      try {
        await new DesactivarPerfilCurso(repository).execute(idPerfilCurso)
        commit('SET_SNACKBAR_MESSAGE', 'El perfil curso se eliminó correctamente.', { root: true })
        await dispatch('fetchPerfilesCursosByAnioCurso', idAnioCurso)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible eliminar el perfil curso.', { root: true })
        throw error
      }
    },

    async crearCategoria({ commit, dispatch }, payload) {
      try {
        await new CrearCategoria(repository).execute(payload)
        commit('SET_SNACKBAR_MESSAGE', 'La categoría se creó correctamente.', { root: true })
        await Promise.all([
          dispatch('fetchCategoriasByTipoCurso', payload.fk_idTipoCurso),
          dispatch('fetchCategoriasByPerfilCurso', payload.fk_idCatPerfilCurso),
        ])
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible crear la categoría.', { root: true })
        throw error
      }
    },

    async actualizarCategoria({ commit, dispatch }, { idCategoria, payload }) {
      try {
        await new ActualizarCategoria(repository).execute(idCategoria, payload)
        commit('SET_SNACKBAR_MESSAGE', 'La categoría se actualizó correctamente.', { root: true })
        await Promise.all([
          dispatch('fetchCategoriasByTipoCurso', payload.fk_idTipoCurso),
          dispatch('fetchCategoriasByPerfilCurso', payload.fk_idCatPerfilCurso),
        ])
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible actualizar la categoría.', { root: true })
        throw error
      }
    },

    async desactivarCategoria({ commit, dispatch }, { idCategoria, idTipoCurso, idCatPerfilCurso }) {
      try {
        await new DesactivarCategoria(repository).execute(idCategoria)
        commit('SET_SNACKBAR_MESSAGE', 'La categoría se eliminó correctamente.', { root: true })
        await Promise.all([
          dispatch('fetchCategoriasByTipoCurso', idTipoCurso),
          dispatch('fetchCategoriasByPerfilCurso', idCatPerfilCurso),
        ])
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible eliminar la categoría.', { root: true })
        throw error
      }
    },

    async desactivarSubcategoria({ commit, dispatch }, idSubcategoria) {
      try {
        await new DesactivarSubcategoria(repository).execute(idSubcategoria)
        commit('SET_SNACKBAR_MESSAGE', 'El curso se eliminó correctamente.', { root: true })
        await dispatch('curso/fetchCursos', null, { root: true })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible eliminar el curso.', { root: true })
        throw error
      }
    },

    async removerAsignacionCurso({ commit }, { idPersonal, idAsignacionCurso }) {
      try {
        await new RemoverAsignacionCurso(repository).execute(idPersonal, idAsignacionCurso)
        commit('SET_SNACKBAR_MESSAGE', 'Asignación de curso removida correctamente.', { root: true })
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible remover la asignación de curso.', { root: true })
        throw new Error('Error al remover asignación de curso')
      }
    },

    async fetchCursosNoProgramadosPersonal({ commit }) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const cursosNoProgramadosPersonal = await new GetAllCursosNoProgramadosPersonal(repository).execute()
        commit('SET_CURSOS_NO_PROGRAMADOS_PERSONAL', cursosNoProgramadosPersonal)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener el personal vinculado a la capacitación.', {
          root: true,
        })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async fetchCursosNoProgramadosByPersonal({ commit }, idPersonal) {
      commit('SET_STATUS', ACTION_STATUS.LOADING)
      try {
        const cursosNoProgramadosDePersonal = await new GetCursosNoProgramadosByPersonal(repository).execute(idPersonal)
        commit('SET_CURSOS_NO_PROGRAMADOS_DE_PERSONAL', cursosNoProgramadosDePersonal)
        commit('SET_STATUS', ACTION_STATUS.SUCCEEDED)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener las capacitaciones del personal.', { root: true })
        commit('SET_STATUS', ACTION_STATUS.FAILED)
      }
    },

    async vincularPersonalACurso({ commit }, payload) {
      try {
        await new VincularPersonalACurso(repository).execute(payload)
        commit('SET_SNACKBAR_MESSAGE', 'El personal se vinculó a la capacitación correctamente.', { root: true })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible vincular el personal a la capacitación.', {
          root: true,
        })
        throw error
      }
    },

    async desvincularPersonalDeCurso({ commit }, idCursoPersonal) {
      try {
        await new DesvincularPersonalDeCurso(repository).execute(idCursoPersonal)
        commit('SET_SNACKBAR_MESSAGE', 'El personal se desvinculó de la capacitación correctamente.', { root: true })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible desvincular el personal de la capacitación.', {
          root: true,
        })
        throw error
      }
    },

    // NOTA (EDF-374): resuelve y cachea el CUIP de un personal por id cuando
    // no está disponible en cuipsPorPersonal (p. ej. candidatos vinculados en
    // sesiones anteriores, antes de que existiera el mapa en memoria).
    // Usa /IPH/EstadoFuerza/personal/:id en vez de personal.fetchPersonalById
    // para no pisar el estado singular personal.personalSingle.
    async fetchCuipPersonal({ commit, state }, fk_idPersonal) {
      if (!fk_idPersonal || state.cuipsPorPersonal[fk_idPersonal]) return
      try {
        const { data } = await axios.get(`/IPH/EstadoFuerza/personal/${fk_idPersonal}`)
        const cuip = data?.data?.[0]?.CUIP
        if (cuip) {
          commit('SET_CUIP_PERSONAL', { fk_idPersonal, cuip })
        }
      } catch {
        // Si falla, la tabla simplemente muestra el CUIP vacío para esa fila.
      }
    },

    async actualizarCursoNoProgramadoPersonal({ commit }, { idCursoPersonal, payload }) {
      try {
        await new ActualizarCursoNoProgramadoPersonal(repository).execute(idCursoPersonal, payload)
        commit('SET_SNACKBAR_MESSAGE', 'La calificación del candidato se actualizó correctamente.', { root: true })
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', error.message || 'No fue posible actualizar la calificación del candidato.', {
          root: true,
        })
        throw error
      }
    },
  },
}
